import React from 'react'
import {Popover, Steps, Row, Col, Input, Select, DatePicker,
    Button, Table, Alert, Pagination, Tooltip, message,
    BackTop, Spin, Tabs} from 'antd'
import common from '@/public/common'
import './list.less'
import { withRouter } from 'react-router-dom'
import {ajaxApi, fileDownloadApiNew, getMethod, submitMethod} from '@/server'
import { summation, getCookie, getCookieNew, getParmUrl, outputMoney, objToArr } from '../../public/utils'
import DateChoose from '../../compenents/dateChoose'
import moment from 'moment'
import { fetchSigoCompany } from '../billVerification/match/common/api'
import _ from 'lodash'
const { Step } = Steps
const { Option } = Select
const { TabPane } = Tabs
const { MonthPicker } = DatePicker
const urlLink = common.SapUrl
// const urlLink='http://192.168.10.67:8120/'
class SupplierList extends React.Component{
   constructor(props) {
       super(props)
       this.state = {
          sping: false,
          search: {
              scs: true,
              po_subject_code:''
          },
          data: [],
          sum: {
            num: 0,
            payable_amount: 0,
            receivable_amount: 0,
            non_payable_amount:0,
            non_receivable_amount:0,
        },
        num: {
            all: 0,
            close: 0,
            send:0,
            confirm: 0,
            part_payment: 0,
            payment: 0,
            submit: 0
        },
        pageSize: 15,
        pageNo: 1,
        current: 1,
        total: 0,
        state: ''
       }
   }
   componentDidMount () {
       this.getList()
       this.fetchSigoCompanyFn()
    // fetchSigoCompany
   }

   fetchSigoCompanyFn = async()=>{
   let res = await fetchSigoCompany()
   let sigoMainBody = objToArr(_.get(res, "data.data") || {})
   this.setState({
    sigoMainBody,
   })
   }
   // 获取列表
   getList = () => {
       this.setState({
           sping: true,
       }, () => {
        let param = {
            name: getCookie('supplierinfo') ? JSON.parse(getCookie('supplierinfo')).code : '',
            ...this.state.search,
            state: this.state.state,
            page_no: this.state.pageNo,
            page_size: this.state.pageSize
        }
        console.log('getList')
        ajaxApi({
            url: urlLink+ 'reconciliation/query-list-out',
            params: param
        }).then((res) => {
          if (res.data) {
              this.setState({
                  sum: res.data.collect,
                  num: res.data.count,
                  data: res.data.data,
                  total: res.data.total_count,
                  sping: false,
              })
          }
        }).catch(err=>{
            this.setState({
                sping: false,
            })
        })
       })
   }
   // input框取值
   changeInput = (name, e) => {
       let _info = this.state.search
       _info[name] = e.target.value
       this.setState({
        search: _info
    })
   }
   changeSelect = (name, val) => {
    let _info = this.state.search
    _info[name] = val
    this.setState({
     search: _info
    })
   }
   // 时间选择
   changTime = (val) => {
       let _info = this.state.search
       if (!val) {
           _info.begin = ''
           _info.end = ''
       } else {
           _info.begin = new Date(val[0]).getTime()
           _info.end = new Date(val[1]).getTime()
       }
       this.setState({
           search: _info
       })
   }
   timeChange = (val) => {
       let _obj = this.state.search
       _obj.time = new Date(moment(val).format('YYYY-MM')).getTime()
       this.setState({
           search: _obj
       })
   }
   search = () => {
        this.setState({
            pageNo: 1,
            current: 1,
            pageSize: 15
        }, () => {
        this.getList()
        })
   }
   // 对账单导出
   export = () => {
       let _obj ={
           ...this.state.search,
           scs_name: getCookie('supplierinfo') ? JSON.parse(getCookie('supplierinfo')).real_name : ''
       }
    fileDownloadApiNew({
        url: urlLink+ '/reconciliation/export-list',
        // url:  'http://192.168.10.67:8120/reconciliation/export-list',
        param: {..._obj,'export_from':'scs',po_subject_code:getCookie('po_subject_code')||''},
        filename: '对账单_' + moment().format("YYYYMMDDHHmmss") + '.xls',
    })
   }
   callback = (key) => {
     this.setState({
         state: key
     }, () => {
         this.getList()
     })
   }
   // 跳转账单号详情
   goDetails = (val) => {
       window.open('http://' + window.location.host + '/main/supplierRecantion/listDetails?code=' + val.reconciliation_code+"&poSubjectName="+val.po_subject_name)
   }
   // 确认单据
   comfire = (record) => {
       let param = {
           state: 'hassupplieraudited',
           code: record.reconciliation_code,
           operate_id: getCookieNew('adminName') ? JSON.parse(getCookieNew('adminName')).UserID : '',
           supplier_id: getCookie('supplierinfo') ? JSON.parse(getCookie('supplierinfo')).code : ''
       }
       ajaxApi({
           url: urlLink + '/reconciliation/update-state',
           params: param
       }).then((res) => {
           if (res) {
               message.success('确认单据成功')
               this.getList()
           }
       })
   }
   // 表格分页
   pageOnChange = (val) => {
     this.setState({
         current: val,
         pageNo: val,
     }, () => {
         this.getList()
     })
   }
   sizeOnchange = (current, size) => {
       this.setState({
           current: current,
           pageNo: current,
           pageSize: size
       }, () => {
           this.getList()
       })
   }

   selectChange = (key, val) => {

    let { search } = this.state
    _.set(search, key, val)
    this.setState({
        search,
    },()=>{
        console.log(this.state.search)
    })
  }

  getColumns=()=>{
    var columns = [
        {
            title: '视客账单号',
            align: 'center',
            // width: 120,
            dataIndex: 'reconciliation_code',
            render: (text,record) => (
            <a onClick={this.goDetails.bind(this, record)}>{text}</a>
            )
        },
           {
            title: <Tooltip title="视客出具账单的时间">出帐时间</Tooltip>,
            align: 'center',
            dataIndex: 'charge_off_time',
            // width: 120,
            render: (text) => (
                <span>{ text ? moment(text).format('YYYY-MM-DD HH:mm:ss') : ''}</span>
                )
           },
           {
            title:<Tooltip title="入库时间/返利应收回时间/付款时间">账期</Tooltip> ,
            align: 'center',
            // width: 200,
            render: (text, record, index) => (
            <span>{record.reconciliation_begin_time ? moment(record.reconciliation_begin_time).format('YYYY-MM-DD') + '~' + moment(record.reconciliation_end_time).format('YYYY-MM-DD') : '' }</span>
            )
           },
           {
            title: <Tooltip title="视客在账期内产生要支付给供应商的货款">视客应付金额</Tooltip>,
            align: 'right',
            dataIndex: 'receivable_amount',
            // width: 120,
            render: (text) => (
             <span>{outputMoney(text)}</span>
             )
        },
        {
            title:<Tooltip title="视客应付金额截止到当前时间剩余未付的货款">视客未付金额</Tooltip> ,
            align: 'right',
            dataIndex: 'non_receivable_amount',
            // width: 120,
            render: (text) => (
             <span>{outputMoney(text)}</span>
             )
        },
        {
            title:<Tooltip title="视客在账期内要向供应商收回的返利">视客应收金额</Tooltip> ,
            align: 'right',
            dataIndex: 'payable_amount',
            // width: 120,
            render: (text) => (
             <span>{outputMoney(text)}</span>
             )
        },
        {
             title:<Tooltip title="视客应收金额截止到当前时间剩余未收的返利">视客未收金额</Tooltip> ,
             align: 'right',
             dataIndex: 'non_payable_amount',
            //  width: 120,
             render: (text) => (
             <span>{outputMoney(text)}</span>
             )
         },
         {
            title: '状态',
            align: 'center',
            dataIndex: 'status_name',
            // width: 120,
        },
           {
            title: '备注',
            align: 'center',
            dataIndex: 'remark',
            width: 150,
            render:text=>text||'--'
           },
           {
               title: '操作',
            //    width: 80,
               render: (text, record, index) => (
                   <span>
                    {
                      record.status === 'submit' ? <a onClick={this.comfire.bind(this, record)}>确认</a> : '--'
                    }
                    </span>
               )
           }

       ]
    //    var addColumns=[
    //     {
    //         title: '已匹配金额',
    //         align: 'center',
    //         dataIndex: 'invoice_amount',
    //         width:120,
    //         render: (text) => (
    //             <span>{outputMoney(text)}</span>
    //         )
    //     },
    //     {
    //         title: '匹配状态',
    //         align: 'center',
    //         dataIndex: 'match_status_name',
    //         width:120,
    //     },
    //     {
    //         title: '未匹配金额',
    //         align: 'center',
    //         dataIndex: 'invoice_remain_amount ',
    //         width:120,
    //         render: (text) => (
    //             <span>{outputMoney(text)}</span>
    //         )
    //     },
    //     {
    //         title: '票单关联号',
    //         align: 'center',
    //         width:120,
    //         dataIndex: 'match_id_list',
    //         render: (text, record) => {
    //             if(!_.get(text, "length")){
    //                 return '-'
    //             }
    //             if (_.get(text, "length") > 1) {
    //               return (
    //                 <Popover
    //                   placement="right"
    //                   content={
    //                     <div>
    //                       {
    //                         (text.filter((item, index) => index != 0) || []).map((_item, _index) => {
    //                           return (
    //                             <div key={_index} onClick={()=>{window.open('http://' + window.location.host + '/main/bill/match/detail?match_id=' + _item)}}>
    //                               <a>{_item}</a>
    //                             </div>
    //                           )
    //                         })
    //                       }
    //                     </div>
    //                   }
    //                 >
    //                   <a onClick={()=>{window.open('http://' + window.location.host + '/main/bill/match/detail?match_id=' + text[0])}}>{text[0]}</a>
    //                 </Popover>
    //               )
    //             } else {
    //               return <a onClick={()=>{window.open('http://' + window.location.host + '/main/bill/match/detail?match_id=' + text[0])}}>{text[0]||"-"}</a>
    //             }
    //           }
    //     },
    //     //匹配状态、已匹配金额、未匹配金额、票单关联号
    //    ]
    //    if(['payment','close'].includes(this.state.state)){
    //     columns.splice(4,0,...addColumns)
    //    }
       return columns
  }
   render () {
       const { sum, num, data, total,search } = this.state
       
       return (
           <div className="sendList">
               <Spin spinning={false}>
               <div className="search">
                   <Alert message={<div>友情提醒：请确保每月最迟15号前确认账单，18号前发票寄达本司，以便我司正常结算。谢谢您的理解和支持！</div>} type="info" showIcon  style={{marginBottom: '15px'}}/>
                   <Row style={{marginBottom: '20px'}}>
                       <Col span={6}>
                           <label>账期所在月份：</label>
                           <MonthPicker onChange={this.timeChange} placeholder="请选择月份"/>
                           {/* <DatePicker format='YYYY-MM' picker="month"  onChange={this.timeChange} /> */}
                       </Col>
                       <Col span={9}>
                           <label>
                               出账时间：
                           </label>
                           <DateChoose
                           ifConvenient={false}
                           isStatus={true}
                           isClick={false}
                           ifshowClear={true}
                           time={true}
                           timerChange={this.changTime}/>
                       </Col>
                       <Col span={5}>
                            <label>视客账单号：</label>
                            <Input placeholder="账单号" style={{width: '65%'}} onChange={this.changeInput.bind(this, 'reconciliation_code')}/>
                       </Col>
                       {/* <Col span={5}>
                            <label>供应商：</label>
                            <Input placeholder="供应商名称、编码"  style={{width: '65%'}} onChange={this.changeInput.bind(this, 'name')}/>
                       </Col> */}
                       {/* <Col span={5}>
                           <label style={{display:'inline-block',width: '40%'}}>对账截止日期：</label>
                           <DatePicker onChange={this.changTime}/>
                       </Col> */}
                       {/* <Col span={4}>
                            <label style={{display:'inline-block',width: '50%'}}>是否SCS供应商：</label>
                            <Select placeholder="请选择"  style={{width: '40%'}} value={this.state.search.scs} onSelect={this.changeSelect.bind(this, 'scs')}>
                                <Option value="">请选择</Option>
                                <Option value={false}>否</Option>
                                <Option value={true}>是</Option>
                            </Select>
                       </Col> */}
                       <Col span={4}>
                           <Button type="primary" onClick={this.search} shape="round">查询</Button>
                           <Button style={{marginLeft: '20px'}} onClick={this.export} shape="round">导出</Button>
                       </Col>
                   </Row>
                       {
                           _.get(this.state, "sigoMainBody.length") > 0 && (
                               <Row>
                                   <Col span={5}>
                                       <label>结算主体：</label>
                                       <Select
                                           allowClear={true}
                                           showSearch
                                           placeholder="请选择"
                                           optionFilterProp="children"
                                           style={{ width: "65%" }}
                                           value={_.get(search, "po_subject_code") || null}
                                           onChange={this.selectChange.bind(this, "po_subject_code")}
                                           filterOption={(input, option) =>
                                               (_.get(option, "label") || '').toLowerCase().includes(input.toLowerCase())
                                           }
                                           options={this.state.sigoMainBody || []}
                                       />
                                   </Col>
                               </Row>
                           )
                       }
               </div>
               <div className="sendBody">
                <Tabs defaultActiveKey="" onChange={this.callback}>
                    <TabPane tab={"全部（" + num.all + '）'} key="">
                    </TabPane>
                    <TabPane tab={[<Tooltip title="视客已提交账单，需供应商进行审核，审核无误后点击“确认” "><span>{"待供应商确认（" + num.submit + '）'}</span></Tooltip>]} key="submit">
                    </TabPane>
                    <TabPane tab={[<Tooltip title="供应商已确认账单，需视客进行确认"><span>{"待视客确认（" + num.confirm + '）'}</span></Tooltip>]} key="confirm">
                    </TabPane>
                    {/* <TabPane tab={[<Tooltip title="视客已确认订单，需供应商完成线下开票，并将发票寄送信息录入系统"><span>{"待供应商邮寄发票（" + (num.send||0) + '）'}</span></Tooltip>]} key="send"> */}
                    {/* </TabPane> */}
                    <TabPane tab={[<Tooltip title="视客已签收发票，等待视客付款"><span>{"待视客付款（" + num.close + '）'}</span></Tooltip>]} key="close">
                    </TabPane>
                    <TabPane tab={[<Tooltip title="视客已支付对账单的部分金额"><span>{"部分付款（" + num.part_payment + '）'}</span></Tooltip>]} key="partPayment">
                    </TabPane>
                    <TabPane tab={[<Tooltip title="视客已支付对账单的所有金额"><span>{"已付款（" + num.payment + '）'}</span></Tooltip>]} key="payment">
                    </TabPane>
                </Tabs>
                <div className="summary">
                    汇总：
                    <span>账单数：<span style={{color: '#f00'}}>{ sum ? sum.num : ''}</span></span>
                    <span style={{marginLeft: '10px'}}>视客未付金额：<span style={{color: '#f00'}}>{sum ? outputMoney(sum.payable_amount) : ''}</span></span>
                    <span  style={{marginLeft: '10px'}}>视客未收金额：<span style={{color: '#f00'}}>{sum ? outputMoney(sum.receivable_amount) : ''}</span></span>
                </div>
                <Table columns={this.getColumns()} dataSource={data} pagination={false} rowKey={index => index} scroll={['payment','close'].includes(this.state.state)&&{x:2000}}/>
                <div className="pagination">
                    <span className="datanum">{'共' + total + '条数据'}</span>
                   <Pagination showQuickJumper showSizeChanger current={this.state.current} total={total} pageSize={this.state.pageSize} pageSizeOptions={['15', '20', '30', '50', '100']} onChange={this.pageOnChange} onShowSizeChange={this.sizeOnchange} />
                </div>
               </div>
               </Spin>
           </div>
       )
   }
}
export default SupplierList



// WEBPACK FOOTER //
// ./src/pages/supplierRecantion/supplierList.js